import { render, staticRenderFns } from "./NegativeResponsesTableCard.vue?vue&type=template&id=5cfd4e62&"
import script from "./NegativeResponsesTableCard.vue?vue&type=script&lang=js&"
export * from "./NegativeResponsesTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports